function getTransactionProducts(order) {
  const transactionProducts = order.order_items.map(order_item => ({
    name: order_item.flower.flower_specie.name,
    sku: `生産者${order_item.farm.id}の${order_item.flower.flower_specie.name}`,
    price: order_item.unit_price_with_cavin_fee,
    quantity: order_item.count,
    category: order_item.flower.category?.name,
    order_item_type: order_item.order_item_type,
    delivery_date: order_item.delivery_date
  }));

  return transactionProducts;
}

export default {
  install(Vue) {
    Vue.prototype.$datalayer = {
      sendData(order) {
        const dataLayer = window.dataLayer || [];

        dataLayer.push({
          event: "purchase",
          transactionId: order.id,
          transactionTotal: order.total_price,
          transactionAffiliation: order.shop.id,
          shopArea: order.location.area?.name,
          transactionProducts: getTransactionProducts(order)
        });
      }
    };
  }
};
